// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__Dcukh","content":"LoadingAlert_content__zY9QS"};